'use client';

import type React from 'react';
import { useAppSelector } from '@/app/hooks';
import { selectSessionUser } from '@/features/session/store/session.selector';

const HeroSection: React.FC = () => {
  const user = useAppSelector(selectSessionUser);

  // Returns user's full name or fallback
  const getUserFullName = () => {
    if (!user) return 'Guest User';
    return (
      `${user.givenName || ''} ${user.familyName || ''}`.trim() ||
      user.email ||
      'User'
    );
  };

  return (
    <div className="text-white flex flex-col px-[40px] py-[48px] bg-[linear-gradient(90deg,rgba(0,0,0,0.40)_27.89%,rgba(0,0,0,0.00)_75.49%),url('/YFSEHeroBannerWeb.png')] bg-cover bg-center bg-no-repeat [background-blend-mode:darken,normal]">
      <p className="text-2xl font-bold">Welcome, {getUserFullName()}</p>
      <p className="text-lg">
        Access all our apps in one place to enhance your productions decisions.
      </p>
    </div>
  );
};

export default HeroSection;
